import { Approval } from 'api/approval';
import { Task, Task as TaskApi } from 'api/tasks';
import { HttpClient } from '../http-client';
import { Project } from '../project';
import { Space, SpaceTab } from '../space';

export enum ApprovalType {
  TaskApproval = 'TASK',
  SpaceTabApproval = 'SPACE_TAB',
}

export type HomeSpaceTab = Pick<SpaceTab, 'spaceTabId' | 'spaceTabTitle'> & {
  space: Pick<Space, 'spaceId' | 'spaceName'> & {
    project: Pick<Project, 'projectId' | 'projectName'>;
  };
};

interface TaskApproval extends Approval {
  associatedEntity: TaskApi;
  associatedEntityType: ApprovalType.TaskApproval;
}

interface SpaceTabApproval extends Approval {
  associatedEntity: HomeSpaceTab;
  associatedEntityType: ApprovalType.SpaceTabApproval;
}

export type ApprovalWithAssociatedEntity = TaskApproval | SpaceTabApproval;

export interface HomeResponse {
  myTasks: Array<TaskApi>;
  approvals: Array<ApprovalWithAssociatedEntity>;
}

class HomeHttpClient extends HttpClient {
  public async getHomeScreenResponse(): Promise<HomeResponse> {
    return this.get<HomeResponse>('/home');
  }

  public async getCsat(): Promise<Task[]> {
    return this.get<Task[]>('/home/get-csat');
  }

  public async getMyCompanyTasks(): Promise<Task[]> {
    return this.get<Task[]>('/home/my-company-tasks');
  }
}

export const HomeAPI = new HomeHttpClient();
